import { ReactNode } from 'react'

export function OrgSelectorDialogMenuItem({
  onClick,
  children,
}: {
  onClick: () => void
  children: ReactNode
}) {
  return (
    <div
      className="relative flex cursor-pointer select-none items-center rounded px-3 py-4 text-base outline-none transition-colors hover:bg-gray-100 data-[disabled]:pointer-events-none data-[disabled]:opacity-50 md:py-2 md:text-sm dark:hover:bg-gray-800"
      onClick={onClick}
    >
      {children}
    </div>
  )
}
